<template>
  <div class="container">
    <div class="box">
      <h1>Please contact me via email:</h1>
      <p><a href="mailto:joshua.lee.glass@gmail.com">joshualeeglass@gmail.com</a></p>
    </div>
    <div class="bottom-container box">
      <h2>If you like this page, please share with your friends below!</h2>
      <vue-goodshare></vue-goodshare>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import VueGoodshare from 'vue-goodshare'
export default {
  name: 'Contact',
  components: {
    AppHeader,
    VueGoodshare
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1 {
    margin-top: 0;
    text-align: center;
    font-size: 1.8em;
  }
  p {
    margin-top: 0;
    margin-bottom: .5em;
  }
  .bottom-container {
    padding-top: 50px;
    bottom: 50px;
  }
  .box {
    background-color: salmon;
    max-width: 70%;
    height: auto;
    margin-left: auto;
    margin-bottom: 25px;
    margin-right: auto;
    padding: 24px;
    border-radius: 8px;
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    box-shadow: 0 15px 20px rgba(0,0,0,0.19), 0 7px 6px rgba(0,0,0,0.23);

    &-footer {
        padding-top: calc(24px - .5em);
        text-align: center;
    }
  }
  .container {
    text-align: center;
    align-items: center;
    height: 100%;
  }
  h2 {
    margin-top: 0;
    text-align: center;
    font-size: 1.8em;
  }
  a {
    color: #fe8854;
    font-weight: 500;
    text-decoration: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue